module.exports = __webpack_public_path__ + "img/introduce05_right03.08f13777.png";